import { gql } from "@apollo/client";

export const QUERY_EVENTS = gql`
	query getEvents {
		getEvents {
            countryId
            name
            type
            projectId
            image
            description
            startHour
            endHour
            startDate
            endDate
            location
            link
            linkGallery
		}
	}
`;
